var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarEventFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5335_118015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08337 1.25033H8.75004C8.86055 1.25033 8.96653 1.29422 9.04467 1.37236C9.12281 1.4505 9.16671 1.55649 9.16671 1.66699V8.33366C9.16671 8.44417 9.12281 8.55015 9.04467 8.62829C8.96653 8.70643 8.86055 8.75033 8.75004 8.75033H1.25004C1.13953 8.75033 1.03355 8.70643 0.955413 8.62829C0.877273 8.55015 0.833374 8.44417 0.833374 8.33366V1.66699C0.833374 1.55649 0.877273 1.4505 0.955413 1.37236C1.03355 1.29422 1.13953 1.25033 1.25004 1.25033H2.91671V0.416992H3.75004V1.25033H6.25004V0.416992H7.08337V1.25033ZM1.66671 3.75033V7.91699H8.33337V3.75033H1.66671ZM2.50004 5.41699H4.58337V7.08366H2.50004V5.41699Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5335_118015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEventFill);
export default __webpack_public_path__ + "static/media/calendar-event-fill.697c46ab2cc151c41d84b5304f9ec08d.svg";
export { ForwardRef as ReactComponent };